import React from "react";
import { Icon } from "semantic-ui-react";
import { injectIntl, FormattedMessage } from "gatsby-plugin-intl";
import { useCookies } from "react-cookie";
import Adsense from "../../components/Adsense";
import Layout from "../../components/Layout";
import { Block } from "../../components/StyledComponent";
import Specification from "../../components/Specification";
import TableFreeOnly from "../../components/TableFreeOnly";
import TableFreeBuy from "../../components/TableFreeBuy";
import EventBanner from "../../components/EventBanner";

const DownloadPage = ({ intl }) => {
  const [cookies, setCookie, removeCookie] = useCookies(); // eslint-disable-line

  return (
    <Layout>
      <EventBanner />
      {intl.locale === "ko" && (
        <Block textAlign="center" visible={!!cookies.picpickupdate}>
          <Adsense type="article" />
        </Block>
      )}
      <Block
        color="gray"
        large
        textAlign="center"
        title={intl.formatMessage({ id: "section_download" })}
      >
        <p>
          <Icon name="exclamation circle" color="orange" />{" "}
          <FormattedMessage id="text_personal_only_detail" />
        </p>
        {intl.locale === "ko" ? <TableFreeOnly /> : <TableFreeBuy />}
      </Block>
      <Block>
        <Specification />
      </Block>
    </Layout>
  );
};

export default injectIntl(DownloadPage);
